import {
  DropdownMenu as DropdownRoot,
  Menu,
  DropdownTrigger,
  MenuItem,
  MenuSection,
} from "./dropdown-menu";

type DropdownMenuType = {
  Root: typeof DropdownRoot;
  Menu: typeof Menu;
  Trigger: typeof DropdownTrigger;
  Item: typeof MenuItem;
  Section: typeof MenuSection;
};

const DropdownMenu: DropdownMenuType = {
  Root: DropdownRoot,
  Menu,
  Trigger: DropdownTrigger,
  Item: MenuItem,
  Section: MenuSection,
};

export { DropdownMenu };
